import { CalendarSlot } from "../slots/api";

export interface Hour {
    label: string,
    hour: number,
    minute: number,
    value: number,
    enabled: boolean,
}

export function compute_hours_from_slots(slots: CalendarSlot[], resolution: number): Hour[] {
    const min_max = [-1, -1];
    slots.forEach(slot => {
        console.log(`compute_hours_from_slots: %o`, slot)
        const h = slot.date.getHours();
        const m = slot.date.getMinutes();
        const x = h * 60 + m;
        if (min_max[0] == -1) {
            min_max[0] = x;
            min_max[1] = x + slot.duration;
        } else {
            min_max[0] = Math.min(min_max[0], x);
            min_max[1] = Math.max(min_max[1], x + slot.duration);
        }
    });
    const hours = [] as Hour[];
    console.log("compute_hours_from_slots: min_max: %o", min_max.map(x => x / 60));
    for (let x = min_max[0]; x < min_max[1]; x += resolution) {
        const h = Math.floor(x / 60);
        const m = Math.floor(x % 60);
        const d = h + m / 60;

        console.log(`compute_hours_from_slots: ${d}`);

        let match = false;
        slots.forEach(slot => {
            const sh = slot.date.getHours();
            const sm = slot.date.getMinutes();
            const sd = sh + sm / 60;
            const sn = sd + slot.duration / 60;
            console.log(`compute_hours_from_slots: \t slot ${sd} -> ${sn}`);
            if (d >= sd && d < sn) {
                console.log(`compute_hours_from_slots: \t\t match`);
                match = slot.count > 0;
            }
        });

        hours.push({
            label: `${h}:${m < 10 ? '0' + m : m}`,
            hour: h,
            minute: m,
            value: x / 60.0,
            enabled: match,
        });
    }
    console.log("compute_hours_from_slots: hours => %o", hours);
    return hours;
}
